import { selectCurrentProgramId } from 'redux/app/program/program.selectors';
import { getStore } from 'redux/store';

export const getProgramId = () => selectCurrentProgramId(getStore().getState());
